export class AsyncMutex {
    private _queue: { resolve: (release: () => void) => void }[] = [];
    private _isLocked = false;

    run<T>(callback: () => Promise<T>): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            this.acquire().then(release => {
                callback()
                    .then(result => {
                        release();
                        resolve(result);
                    })
                    .catch(error => {
                        release();
                        reject(error);
                    });
            });
        });
    }

    acquire(): Promise<() => void> {
        return new Promise<() => void>(resolve => {
            if (!this._isLocked) {
                this._isLocked = true;
                resolve(this.buildRelease());
                return;
            }
            this._queue.push({ resolve });
        });
    }

    private buildRelease(): () => void {
        return () => {
            if (this._queue.length > 0) {
                const next = this._queue.shift();
                if (next) {
                    next.resolve(this.buildRelease());
                }
            } else {
                this._isLocked = false;
            }
        };
    }

    isLocked(): boolean {
        return this._isLocked;
    }
}
